import { render } from "./OrderToday.vue?vue&type=template&id=5e39d3a4&scoped=true"
import script from "./OrderToday.vue?vue&type=script&lang=js"
export * from "./OrderToday.vue?vue&type=script&lang=js"

import "./OrderToday.vue?vue&type=style&index=0&id=5e39d3a4&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e39d3a4"]])

export default __exports__